import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import BackButton from "./components/BackButton";
import ScrollToTop from "./components/ScrollToTop";
import RequireAuth from "./components/RequireAuth";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import AppointmentPage from "./pages/AppointmentPage";
import ContactPage from "./pages/ContactPage";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminAppointments from "./pages/admin/AdminAppointments";
import AdminServices from "./pages/admin/AdminServices";
import AdminGallery from "./pages/admin/AdminGallery";
import AdminDoctors from "./pages/admin/AdminDoctors";
import AdminTestimonials from "./pages/admin/AdminTestimonials";
import AdminBlog from "./pages/admin/AdminBlog";
import AdminFAQ from "./pages/admin/AdminFAQ";
import AdminSubscribers from "./pages/admin/AdminSubscribers";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminContactMessages from "./pages/admin/AdminContactMessages";

function AppLayout() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  return (
    <div className={`app-shell${isAdminRoute ? " admin-app-shell" : ""}`}>
      <ScrollToTop />
      <Navbar />
      <div className={`container py-4 page-shell${isAdminRoute ? " admin-page-shell" : ""}`}>
        <BackButton />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/appointment" element={<AppointmentPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <RequireAuth>
                <AdminDashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/appointments"
            element={
              <RequireAuth>
                <AdminAppointments />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/services"
            element={
              <RequireAuth>
                <AdminServices />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/gallery"
            element={
              <RequireAuth>
                <AdminGallery />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/doctors"
            element={
              <RequireAuth>
                <AdminDoctors />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/testimonials"
            element={
              <RequireAuth>
                <AdminTestimonials />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/blog"
            element={
              <RequireAuth>
                <AdminBlog />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/faqs"
            element={
              <RequireAuth>
                <AdminFAQ />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/subscribers"
            element={
              <RequireAuth>
                <AdminSubscribers />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/contact-messages"
            element={
              <RequireAuth>
                <AdminContactMessages />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/settings"
            element={
              <RequireAuth>
                <AdminSettings />
              </RequireAuth>
            }
          />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <ToastProvider>
          <Router>
            <AppLayout />
          </Router>
        </ToastProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}
export default App;
